import React from 'react';
import ListingPage from './ListingPage';

/** Logged-in hosts: same wizard as /listing without the create-account step. */
const AddPropertyListingPage = () => <ListingPage mode="add-property" />;

export default AddPropertyListingPage;
